import { useEffect, useRef } from 'react';
import { safelyParseJson } from '../utils';
import { usePubSub } from './usePubSub';
const checkIsMessageData = messageData => !!messageData['@type'];
const checkIsMessageMatch = (messageData, messageType) => checkIsMessageData(messageData) && messageData['@type'] === messageType;
export const useAblyChannel = ({
  channel,
  type,
  onMessage,
  onPlayback
}) => {
  const ablyClient = usePubSub();
  const onMessageRef = useRef(onMessage);
  const onPlaybackRef = useRef(onPlayback);
  useEffect(() => {
    onMessageRef.current = onMessage;
  }, [onMessage]);
  useEffect(() => {
    onPlaybackRef.current = onPlayback;
  }, [onPlayback]);
  useEffect(() => {
    const listener = message => {
      const messageData = safelyParseJson(message.data);
      if (checkIsMessageMatch(messageData, type)) {
        onMessageRef.current(messageData);
      }
    };
    const playbackListener = messages => {
      const messagesData = messages.reduce((acc, message) => {
        const messageData = safelyParseJson(message.data);
        if (checkIsMessageMatch(messageData, type)) {
          acc.push(messageData);
        }
        return acc;
      }, []);
      onPlaybackRef.current(messagesData);
    };
    if (ablyClient) {
      // disabling because we don't need async logic here
      // eslint-disable-next-line @typescript-eslint/no-floating-promises
      ablyClient.subscribe({
        channelId: channel,
        playbackMessages: true,
        onMessage: listener,
        onPlayback: playbackListener
      });
    }
    return () => {
      if (ablyClient) {
        // disabling because we don't need async logic here
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        ablyClient.unsubscribe({
          channelId: channel,
          onMessage: listener
        });
      }
    };
  }, [ablyClient, channel, type]);
};